import React, {Component, Fragment } from 'react';
import Helmet from 'react-helmet';

// JOHNデザインログイン画面
function getDesign({ design, loading, messageListLogin, errMap, state,
  autoLoginStateFlg, autoLoginId, handleChangeMethod, swhichPwdShowMethod, handleKeyPressMethod, loginMethod }) {
  return (
    <section>
      {(design === "JH001N") ?
        <Helmet
          title={messageListLogin.M001_browserTitle_john} >
        </Helmet> :
        <Helmet
          title={messageListLogin.M001_browserTitle_john_report} >
        </Helmet>}

      { // Loadingモーダル表示
        loading &&
        <div id="loading" className="loading-modal"><img className="loading-img" src={`${process.env.PUBLIC_URL}/img/load.gif`} alt="loading" /></div>
      }

      {/* 画面タイトル表示部 */}
      <div className="hdg-l1">
        {(design === "JH001N") ?
          <h1 className="hdg-l1_txt">{messageListLogin.M002_pageTitle_john}</h1> :
          <h1 className="hdg-l1_txt">{messageListLogin.M002_pageTitle_john_report}</h1>}
      </div>

      <div id="JS_error">
        { // エラーメッセージ表示
          (errMap && errMap.ERROR) &&
          <div className="panel-attention">
            <h2 className="panel-attention_hdg">
              <span className="panel-attention_icon">
                <img src={`${process.env.PUBLIC_URL}/img/icon_error.svg`} alt={messageListLogin.M003_errorIconText} />
              </span>{messageListLogin.M004_errorBoxTitle}
            </h2>
            <p>{errMap.ERROR}</p>
          </div>/* /panel-attention */
        }
      </div>

      <div className="panel-form">
        <div className="panel-form-inner">
          <div className="panel-form-inner_item">
            <form name="dummy" id="JS_jmbForm">
              {/* 画面項目表示部 */}
              {/* ID */}
              <div className="panel-form-inner_parts">
                {(!autoLoginStateFlg) ?
                  <Fragment>
                    <p className="form-label"><label htmlFor="LA_input-number-01">{messageListLogin.M005_id_john}</label></p>
                    <input type="tel" id="LA_input-number-01" name="id"
                      className={errMap && errMap.errorId === 'id' ? "form-txt js-form-validate-blank JS_jmbNo is-blank is-error" :
                        "form-txt js-form-validate-blank JS_jmbNo is-blank"}
                      maxLength="9" placeholder="" aria-invalid={errMap && errMap.errorId === 'id' ? "true" : "false"}
                      value={state.id} onChange={handleChangeMethod} />
                  </Fragment>
                  :
                  <Fragment>
                    <p className="form-label"><label htmlFor="LA_input-number-02">{messageListLogin.M005_id_john}</label></p>
                    <input type="tel" id="LA_input-number-02" className="form-txt js-form-validate-blank JS_jmbNo" maxLength="9"
                      placeholder="" aria-invalid="false" readOnly defaultValue={autoLoginId} tabIndex="-1" />
                  </Fragment>
                }
              </div>

              {/* パスワード */}
              <div className="panel-form-inner_parts">
                <p className="form-label"><label htmlFor="LA_input-password">{messageListLogin.M006_password}</label></p>
                <p className="form-table_txt mb-form-label">
                  <a href="https://www.jal.co.jp/jp/ja/jmb/jmb-login/password/" className="link-txt _other" target="otherwindow">
                    <img src={`${process.env.PUBLIC_URL}/img/icon_blank_rd.svg`} alt={messageListLogin.M026_newWindowIcon} className="icon-blank" />
                    {messageListLogin.M007_aboutPassword}
                  </a>
                </p>
                <input type={state.showPwd ? "text" : "password"} id="LA_input-password" name="password"
                  className={errMap && errMap.errorId === 'password' ? "form-txt js-form-validate-blank JS_jmbPass is-blank is-error" :
                    "form-txt js-form-validate-blank JS_jmbPass is-blank"}
                  maxLength="256" placeholder="" aria-invalid={errMap && errMap.errorId === 'password' ? "true" : "false"}
                  value={state.password} onChange={handleChangeMethod}
                  onKeyPress={handleKeyPressMethod} />

                {/* パスワードを表示する */}
                <span className="form-checkbox _block">
                  <input type="checkbox" id="LA_form-checkbox-01" name="__dummy__" aria-controls="LA_input-password" onChange={swhichPwdShowMethod} />
                  <label htmlFor="LA_form-checkbox-01" className="form-checkbox_item is-blank">{messageListLogin.M008_showPassword}</label>
                </span>
              </div>

              {/* パスワードを初期化する */}
              <div className="form-box-wrap ">
                <a href={"./pwd_reset?design=" + sessionStorage.getItem('design') + "&lang=" + sessionStorage.getItem('lang')} className="link-txt _other" target="_blank">
                  <img src={`${process.env.PUBLIC_URL}/img/icon_blank_rd.svg`} alt={messageListLogin.M026_newWindowIcon} className="icon-blank" />
                  {messageListLogin.M054_pwdReset}
                </a>
              </div>

              {/* 操作ボタン表示部 */}
              <div className="btn-wrap">
                <div>
                  <button type="button" name="__dummy__" className="btn" onClick={loginMethod}>{messageListLogin.M011_login}</button>
                </div>
              </div>

              {/* リンク表示部 */}
              <div className="form-box-wrap">
                <p className="form-table_txt mb-form-label">
                  <a href={`${process.env.REACT_APP_URL_NOTICE_MANAGER_LOGIN}`} className="link-txt _other" target="otherwindow">
                    <img src={`${process.env.PUBLIC_URL}/img/icon_blank_rd.svg`} alt={messageListLogin.M026_newWindowIcon} className="icon-blank" />
                    {messageListLogin.M055_linkJmbLogin}
                  </a>
                </p>
                <p className="form-table_txt mb-form-label">
                  <a href={`${process.env.REACT_APP_URL_NOTICE_CORPORATE_LOGIN}`} className="link-txt _other" target="otherwindow">
                    <img src={`${process.env.PUBLIC_URL}/img/icon_blank_rd.svg`} alt={messageListLogin.M026_newWindowIcon} className="icon-blank" />
                    {messageListLogin.M056_linkCorporateLogin}
                  </a>
                </p>
                <p className="form-table_txt mb-form-label">
                  <a href={`${process.env.REACT_APP_URL_NOTICE_SELF_EMPLOYEE_LOGIN}`} className="link-txt _other" target="otherwindow">
                    <img src={`${process.env.PUBLIC_URL}/img/icon_blank_rd.svg`} alt={messageListLogin.M026_newWindowIcon} className="icon-blank" />
                    {messageListLogin.M057_linkSelfLogin}
                  </a>
                </p>
              </div>
            </form>
          </div> {/* /panel-form-inner_item */}
        </div> {/* /panel-form-inner */}
      </div>

      {/* リンク表示部 */}
      <div className="hdg-guide">
        <h2 className="hdg-guide_txt">{messageListLogin.M013_notices}</h2>
      </div>
      <ul className="list">
        <li>{messageListLogin.M058_notice013}
          <a href="https://www.jal.co.jp/jp/ja/jmb/jmb-login/number-info/" className="link-txt _other" target="_blank">
            <img src={`${process.env.PUBLIC_URL}/img/icon_blank_rd.svg`} alt={messageListLogin.M026_newWindowIcon} className="icon-blank" />
            {messageListLogin.M059_notice014}
          </a>
          {messageListLogin.M060_notice015}
        </li>
        <li>{messageListLogin.M018_notice005}<br></br>
          {messageListLogin.M019_notice006}</li>
        <li>{messageListLogin.M020_notice007}
          <div>
            <a href="https://www.jal.co.jp/jp/ja/jmb/jmb-login/number-info/" className="link-txt _other" target="otherwindow">
              <img src={`${process.env.PUBLIC_URL}/img/icon_blank_rd.svg`} alt={messageListLogin.M026_newWindowIcon} className="icon-blank" />
              {messageListLogin.M021_notice008}
            </a>
          </div>
        </li>
        <li>{messageListLogin.M061_notice016}
          <a href="https://www.jal.co.jp/jalonline/policy/browser.html" className="link-txt _other" target="_blank">
            <img src={`${process.env.PUBLIC_URL}/img/icon_blank_rd.svg`} alt={messageListLogin.M026_newWindowIcon} className="icon-blank" />
            {messageListLogin.M062_notice017}
          </a>
          {messageListLogin.M063_notice018}
        </li>
        <li>{messageListLogin.M064_notice019}
          <a href="https://www.jal.co.jp/jalonline/rule/security.html" className="link-txt _other" target="_blank">
            <img src={`${process.env.PUBLIC_URL}/img/icon_blank_rd.svg`} alt={messageListLogin.M026_newWindowIcon} className="icon-blank" />
            {messageListLogin.M065_notice020}
          </a>
          {messageListLogin.M066_notice021}
        </li>
        <li>{messageListLogin.M022_notice009}</li>
        <li>{messageListLogin.M067_notice022}
          <div>
            <a href="https://www.jal.co.jp/cgi-bin/jal/jmb/enroll/index.cgi" className="link-txt _other" target="otherwindow">
              <img src={`${process.env.PUBLIC_URL}/img/icon_blank_rd.svg`} alt={messageListLogin.M026_newWindowIcon} className="icon-blank" />
              {messageListLogin.M068_notice023}
            </a>
          </div>
        </li>
      </ul>
    </section>
  );
}

export { getDesign }